import { CSP_NONCE, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css'],
  providers: []
})

export class WelcomeComponent implements OnInit{

  cspNonceV: any;
  userData: any = [];

  //@Inject(CSP_NONCE) private cspNonce: Observable<string>,
  constructor(private userService: UserService, private router: Router, @Inject(CSP_NONCE) private cspNonce: string,
  private userDataService: UserDataService){
    this.cspNonceV = cspNonce;
    this.userData = this.userDataService.getUserData();
    //console.log(this.cspNonceV);
    /*this.cspNonceV.subscribe((cspNonce: string) => {
      this.cspNonceV = cspNonce;
      console.log(this.cspNonceV);
    });*/
  }

  ngOnInit(): void {}

  enter(){
    if(this.userService.hasLocalSessionToken()){
      this.router.navigateByUrl("/home/establecimientos");
      /*if(this.userData.pro_id === 4){
        this.router.navigateByUrl("/home/establecimientos");
      } else {
        this.router.navigateByUrl("/home");
      }*/
    }else{
      this.router.navigateByUrl("/login");
    }
    /*if(this.userService.sessionTokenExists()){
      this.router.navigateByUrl("/home");
    }else{
      this.router.navigateByUrl("/login");
    }*/
  }

}
